import React, { useState, useEffect } from "react";
import { Button, Modal, Card, Form, Row, Col } from "react-bootstrap";
import ReactSelect from 'react-select';
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { STUDENT , NOTIFICATION_TYPES, SMS_TYPE, EMAIL_TYPE } from "../../constants";

const SendNotification = (props) => {
  const { data, closeModal , sendMessage } = props;
  console.log(data)
  const [show, setShow] = useState(props.show);
  const validationSchema = Yup.object().shape({
    subject: Yup.string().required("Subject Name is required"),
    content: Yup.string().required("Message is required"),
    notifiableType: Yup.string().default(STUDENT),
    notificationType: Yup.object().required("Notification Type is required").nullable(),
  });

  useEffect(() => {
    setShow(props.show);
    reset();
  }, [props.show]);

  const {
    register,
    handleSubmit,
    reset,
    watch,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const handleClose = () => {
    setShow(false);
    closeModal();
  };
  const handleShow = () => setShow(true);
  const onSubmit = async(data)=>{
    let reqParams = { ...data};
    reqParams.notificationType = data.notificationType.value;
    await sendMessage(reqParams)
    closeModal();
  }
  return (
    <>
      <Modal show={show} size="lg" onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Notify Student</Modal.Title>
        </Modal.Header>
        <Form noValidate onSubmit={handleSubmit(onSubmit)}>
        <Modal.Body>
        <Form.Group
              as={Row}
              className="mb-3 required"
              controlId="formPlaintextEmail"
            >
              <Form.Label column sm="4">
                Notification Type
              </Form.Label>
              <Col sm="6">
                <Controller
                  name="notificationType"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <ReactSelect
                        isClearable
                        {...field}
                        options={[{value: EMAIL_TYPE,label: EMAIL_TYPE}]}
                        className={`${errors.notificationType ? "is-invalid" : ""}`}
                        isOptionDisabled={(option) => option.disabled}
                      />
                      <span className="invalid-feedback">
                        {errors.notificationType?.message}
                      </span>
                    </>
                  )}
                  {...register("notificationType")}
                />
              </Col>
            </Form.Group>
        <Form.Group
              as={Row}
              className="mb-3 required"
              controlId="formPlaintextEmail"
            >
              <Form.Label column sm="4">
                Student Name
              </Form.Label>
              <Col sm="6">
                <Form.Control
                  type="text"
                  name="subject"
                  value={data.Student.User.firstName + " " + data.Student.User.lastName}
                  disabled ={true}
                ></Form.Control>
               
              </Col>
            </Form.Group>
        <Form.Group
              as={Row}
              className="mb-3 required"
              controlId="formPlaintextEmail"
            >
              <Form.Label column sm="4">
                Subject
              </Form.Label>
              <Col sm="6">
                <Form.Control
                  type="text"
                  name="subject"
                  className={`form-control ${
                    errors.subject ? "is-invalid" : ""
                  }`}
                  {...register("subject")}
                ></Form.Control>
                <span className="invalid-feedback">
                  {errors.subject?.message}
                </span>
              </Col>
            </Form.Group>
            <Form.Group
              as={Row}
              className="mb-3 required"
              controlId="formPlaintextEmail"
            >
              <Form.Label column sm="4">
                Message
              </Form.Label>
              <Col sm="6">
                <Form.Control
                  as="textarea"
                  rows={3}
                  name="content"
                  className={`form-control ${
                    errors.content ? "is-invalid" : ""
                  }`}
                  {...register("content")}
                ></Form.Control>
                <span className="invalid-feedback">
                  {errors.content?.message}
                </span>
              </Col>
            </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary app-default-button" type="submit">
            Notify Student
          </Button>
        </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};

export default SendNotification;
